/* global AppSettings */
/**
 * Check if postcode is deliverable.
 * NOTE block saving the address only on the delivery page
 * at the form which has CSS class name 'js-change-add-address'
 *
 * @author Andy Lemaire <andy.lemaire@elision.eu>
 * @author Vincent Bruijn <vincent-bruijn@g-star.com>
 */
import $ from 'jquery';
import Factory from 'components/utils/Factory';
import Mustache from 'mustache';
import createLogger from 'components/logger/Logger';

const Logger = createLogger('PostcodeValidation');

const errorTemplate = '<div class="formInputError"><span class="error">{{{message}}}</span></div>';
  const warningTemplate =
    '<div class="formInputError"><span class="warning">{{{message}}}</span></div>';

  function PostcodeValidation($element) {
    this.$element = $element;
    this.$form = this.$element.parents('form');
    this.formApi = this.$form.data('api');

    this.isBlockSaveAddress = this.$form.hasClass('js-change-add-address') || false;

    this.bindEvents();
  }

  $.extend(PostcodeValidation.prototype, {
    bindEvents() {
      this.$element.on('blur', this.onFocusOutCheckDeliverability.bind(this));

      this.formApi.attachSubmitCallback(this.preSubmitCheckDeliverability.bind(this), 1);
    },

    doApiCall() {
      const addressData = {};
      addressData.postcode = this.$element.val();
      if (!addressData.postcode) {
        return $.Deferred().resolve();
      }
    addressData.CSRFToken = this.$element
      .parents('form')
      .find('[name="CSRFToken"]')
      .val();

      return $.ajax({
        type: 'post',
        url: AppSettings.endpoints.postcodeValidation,
        data: addressData,
        dataType: 'json',
      })
      .done(response => {
        this.$element
          .closest('.formInputGroup')
          .find('.formInputError')
          .remove();
          this.$element.closest('.formInputGroup').removeClass('invalid');

          if (response.valid !== true) {
            this.renderMessage(response.message);
          } else {
            this.$form.find('.js-error-message').hide();
          }

          this.$element.attr(
            'data-is-allowed-postcode-save',
            response.valid || !this.isBlockSaveAddress
          );
        })
      .fail(response => {
          Logger.warn(`Postalcode delivery validation failed: ${response}`);
        });
    },

    onFocusOutCheckDeliverability() {
      const xhr = this.doApiCall();

      xhr.always(() => this.$element.trigger('change'));
    },

    preSubmitCheckDeliverability() {
      const deferred = $.Deferred();

      const xhr = this.doApiCall();
      xhr.done((response) => {
        if ((response && response.valid.toString() === 'true') || !this.isBlockSaveAddress) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      });

      return deferred.promise();
    },

    renderMessage(msg) {
      const $inputGroup = this.$element.closest('.formInputGroup');

      if (this.isBlockSaveAddress) {
        $inputGroup.append(Mustache.render(errorTemplate, { message: msg }));
        $inputGroup.addClass('invalid');
      } else {
        $inputGroup.append(Mustache.render(warningTemplate, { message: msg }));
      }
    },
  });

export default Factory.create(PostcodeValidation);
